import React, { useState } from "react";
import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";
import { api } from "../../../app/Api/ApiSlice";
import { usePaystackPayment } from "react-paystack";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const AdPayment = () => {
    const [paymentMethod, setPaymentMethod] = useState("mpesa");
    const [phone, setPhone] = useState("");
    const [loading, setLoading] = useState(false);

    const { organization } = useParams()
    const location = useLocation()
    const { ad } = location.state
    const navigate = useNavigate()

    // console.log(ad)


    const userEmail = "user@example.com"; // replace with auth user email
    const reference = `ONNIZE_${Date.now()}`;

    /* =======================
       M-PESA
    ======================== */
    const handleMpesaPayment = async () => {
        setLoading(true);
        try {
            await api.post(`/payments/mpesa`, {
                phone,
                amount: ad.budget,
            });

            alert("M-Pesa prompt sent. Check your phone.");
        } catch (err) {
            console.log(err)
            alert("Failed to initiate M-Pesa payment");
        } finally {
            setLoading(false);
        }
    };

    /* =======================
       PAYSTACK
    ======================== */
    // console.log("env:",process.env.REACT_APP_PAYSTACK_PUBLIC_KEY)
    const paystackConfig = {
        reference,
        email: userEmail,
        amount: ad.budget, // ksh
        publicKey: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY,
        currency: "KES",
    };

    const initializePaystack = usePaystackPayment(paystackConfig);

    const verifyPaystackPayment = async (ref) => {
        try {
            setLoading(true);
            const res = await api.get(`/paystack/verify/${ref}`);

            if (res.data.success) {
                toast.success("payment succesful")
                navigate(`/${organization}/admin`)
            } else {
                alert("Payment verification failed");
            }
        } catch (err) {
            alert("Verification error");
        } finally {
            setLoading(false);
        }
    };

    const handlePaystackPayment = () => {
        initializePaystack(
            (ref) => {
                verifyPaystackPayment(ref.reference);
            },
            () => {
                // console.log("Paystack checkout closed");
            }
        );
    };

    return (
        <div className="checkout">
            <h2>Complete ad Payment</h2>

            {/* SUMMARY */}
            <div className="summary">
                <p><strong>{ad.name}</strong></p>
                <p>
                    Amount: {ad.currency} {ad.budget}
                </p>
            </div>

            {/* PAYMENT METHOD SELECTOR */}
            <div className="methods">
                <button
                    className={paymentMethod === "mpesa" ? "active" : ""}
                    onClick={() => setPaymentMethod("mpesa")}
                >
                    M-Pesa
                </button>

                <button
                    className={paymentMethod === "paystack" ? "active" : ""}
                    onClick={() => setPaymentMethod("paystack")}
                >
                    Paystack
                </button>

                <button
                    className={paymentMethod === "paypal" ? "active" : ""}
                    onClick={() => setPaymentMethod("paypal")}
                >
                    PayPal
                </button>
            </div>

            {/* =======================
                M-PESA UI
            ======================== */}
            {paymentMethod === "mpesa" && (
                <div className="payment-section">
                    <label>M-Pesa Phone Number</label>
                    <input
                        type="tel"
                        placeholder="2547XXXXXXXX"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        required
                    />

                    <button onClick={handleMpesaPayment} disabled={loading} className="payment-btn">
                        {loading ? "Processing..." : "Pay with M-Pesa"}
                    </button>
                </div>
            )}

            {/* =======================
                PAYSTACK UI
            ======================== */}
            {paymentMethod === "paystack" && (
                <div className="payment-section">
                    <button onClick={handlePaystackPayment} disabled={loading} className="payment-btn">
                        {loading ? "Redirecting..." : "Pay with Paystack"}
                    </button>
                </div>
            )}

            {/* =======================
                PAYPAL UI
            ======================== */}
            {paymentMethod === "paypal" && (
                <div className="payment-section">
                    <PayPalScriptProvider
                        options={{
                            "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
                            currency: "KSH",
                        }}
                    >
                        <PayPalButtons
                            createOrder={async () => {
                                const res = await api.post(
                                    "/payments/paypal/create-order",
                                    { amount: ad.budget }
                                );
                                return res.data.id;
                            }}
                            onApprove={async (data) => {
                                await api.post(
                                    "/payments/paypal/capture-order",
                                    { orderID: data.orderID }
                                );
                                alert("PayPal payment successful");
                            }}
                            onError={() => {
                                alert("PayPal payment failed");
                            }}
                        />
                    </PayPalScriptProvider>
                </div>
            )}
        </div>
    );
};

export default AdPayment;
